<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_Box') + '-' + $t('CargoMsg.Cargo_Edit')"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
    :show-close="false"
    :modal-append-to-body="false"
    width="400px"
  >
    <div style="margin-bottom: 10px; height: 100%">
      <div style="margin-left: 10px">{{ totalLabel }}</div>
      <div style="float: right; margin-bottom: 5px;margin-top: 5px">
        <el-button no="1" type="primary" @click="add">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
        <el-button no="2" type="danger" @click="del">{{ $t('SeaExport.Delete') }}</el-button>
      </div>
      <cargo-ag-grid
        no="3"
        config-module="150020"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="height: 100%;"
        @gridReady="params=>{gridApi=params.api}"
      />
      <span slot="footer">
        <el-button no="3" type="primary" @click="save">{{ $t('common.btn.confirm') }}</el-button>
      </span>
    </div>
  </el-dialog>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor/index'
import { formatNumberToThousands } from '@/utils'

export default {
  name: 'AirlineProductVoyageBoardDialog',
  props: {
    rowData: { type: Array, default: () => [] },
    visible: { type: Boolean, required: true }
  },
  data() {
    return {
      innerVisible: this.visible,
      selectedItem: null,
      delVoyageBoardKeys: [],
      totalLabel: '',
      gridOptions: {
        rowSelection: 'multiple',
        singleClickEdit: true,
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        context: {
          componentParent: this
        },
        frameworkComponents: {
          CargoAgGridCommonInputEditor,
          CargoAgGridAdvanceSelectEditor
        }
      },
      gridApi: null,
      columnDefs:
         [
           {
             headerName: '', width: 55, checkboxSelection: true,
             pinned: 'left',
             sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
             headerCheckboxSelection: true
           },
           {
             headerName: this.$t('CargoMsg.Cargo_SequenceNumber'),
             field: 'serialNumber',
             cellEditor: 'CargoAgGridCommonInputEditor',
             flex: 1
           }, {
             headerName: this.$t('CargoMsg.Cargo_Unit_Load_Device'),
             field: 'airplaneContainerCode',
             editable: true,
             cellEditor: 'CargoAgGridAdvanceSelectEditor',
             cellEditorParams: {
               selectProps: {
                 selectType: TYPE_NAMES.basic_data_AirplaneContainer,
                 filterable: true,
                 tagName: 'code',
                 tagValue: 'code',
                 filterTagNames: ['code']
               }
             },
             valueFormatter: params => {
               return params.value
             },
             width: 100,
             onCellValueChanged: p => this.initTotalLabel()
           }, {
             headerName: this.$t('CargoMsg.Cargo_Unit_Load_Device') + this.$t('CargoMsg.Cargo_AmountNumber'),
             colId: 'airplaneContainerCount',
             field: 'airplaneContainerCount',
             width: 100,
             valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 0, true)),
             editable: true,
             cellEditor: 'CargoAgGridCommonInputEditor',
             cellEditorParams: {
               isNumber: true,
               inputProps: {
                 precision: 0
               }
             },
             onCellValueChanged: p => this.initTotalLabel()
           }
         ]
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    this.initTotalLabel()
  },
  methods: {
    // 列编辑修改事件
    initTotalLabel() {
      let count = 0
      const label = []
      for (const row of this.rowData) {
        if (row.airplaneContainerCode) {
          count += Number(row.airplaneContainerCount)
          label.push(row.airplaneContainerCode + ' * ' + row.airplaneContainerCount)
        }
      }
      this.totalLabel = this.$t('CargoMsg.Cargo_AmountTo') + '：' + this.$t('CargoMsg.Cargo_BoardCount') + '：' +
        count + ' / ' + label.join(' ; ')
    },
    add() {
      const length = this.rowData ? this.rowData.length + 1 : 1
      const data = {
        serialNumber: length,
        airplaneContainerCode: '',
        airplaneContainerCount: 0
      }
      this.rowData.push(data)
    },
    del() {
      const rows = this.gridApi.getSelectedRows()
      if (!rows || rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      for (let i = this.rowData.length - 1; i >= 0; --i) {
        const row = this.rowData[i]
        if (rows.includes(row)) {
          if (row.uuid) {
            this.delVoyageBoardKeys.push(row.uuid)
          }
          this.rowData.splice(i, 1)
        }
      }
      this.$nextTick(() => {
        // 重置序号
        for (let i = 0; i < this.rowData.length; i++) {
          const data = this.rowData[i]
          data.serialNumber = i + 1
        }
        this.gridApi.refreshCells({ force: true })
        this.gridApi.clearFocusedCell()
      })
    },
    save() {
      if (this.rowData) {
        for (const row of this.rowData) {
          if (!row.airplaneContainerCode) {
            this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_Unit_Load_Device'))
            return
          }
        }
      }
      this.$emit('save', this.delVoyageBoardKeys)
      this.innerVisible = false
    }
  }
}
</script>

<style scoped>

</style>
